<div class="position-relative">
  <input
    type="text"
    class="form-control"
    placeholder="{{ placeholder | translate }}"
    #searchInput
    [class.disabled]="max && selectedList && selectedList.length >= max"
    [formControl]="searchCtrl"
    (focus)="onfocus()"
    (blur)="onblur()"
  />
  @if (max) {
    <div class="input-desc tw-text-[0.9rem] tw-italic">
      {{ 'company.enterMaxSector' | translate: { max: max } }}
    </div>
  }
  @if (focus && isLoading) {
    <div class="sector-list bg-fill">
      <agmo-loading></agmo-loading>
    </div>
  }
  @if (focus && !isLoading && list) {
    <div class="sector-list">
      <ul class="list-group list-group-flush">
        @if (popularSectors && popularSectors.length > 0) {
          <li class="list-group-title">{{ 'common.popularSectors' | translate }}</li>
          @for (item of popularSectors; track item) {
            <li class="list-group-item" (click)="addItem(item)">
              {{ item.name }}
            </li>
          }
        }
        @if (commonSectors && commonSectors.length > 0) {
          <li class="list-group-title">{{ 'common.others' | translate }}</li>
          @for (item of commonSectors; track item) {
            <li class="list-group-item" (click)="addItem(item)">
              {{ item.name }}
            </li>
          }
        }
      </ul>
    </div>
    @if (list && !list.popularSectors && list.commonSectors?.length == 0 && searchCtrl.value) {
      <div class="sector-list">
        <ul class="list-group list-group-flush">
          <li class="list-group-item">
            {{ 'common.noRecord' | translate }}
          </li>
        </ul>
      </div>
    }
  }
  @if (selectedList && selectedList.length > 0) {
    <div class="mt-2">
      @if (sectorListLabel) {
        <div class="text-black font-weight-bold sector-list-label">
          {{ sectorListLabel | translate }}
        </div>
      }
      @for (item of selectedList; track item) {
        <div class="block-badge-wrap">
          <div class="d-flex flex-row block-badge mr-3">
            <div class="font-weight-bold mr-2">{{ item.name }}</div>
            <div class="mr-2">|</div>
            <div class="align-self-center pointer" (click)="deleteItem(item.id)">
              <i class="fa fa-times" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>
